module.exports = __webpack_public_path__ + "static/media/Rider-TechSheet-DEADFUCK2025.2762016b.pdf";